import { CampaignCategories, MyCustomerReportTypes, ReminderIDs } from "src/core/constants";
import { hyphenate } from "zeta-dom/util";

interface RouteParamMap<T> {
    toRouteParam(value: Zeta.ValueOf<T>): string | undefined;
    fromRouteParam(value: string): Zeta.ValueOf<T> | undefined;
}

function createMap<T extends Zeta.Dictionary<string>>(dict: T): RouteParamMap<T> {
    let forward: Partial<Record<Zeta.ValueOf<T>, string>> = {};
    let reverse: Partial<Record<string, Zeta.ValueOf<T>>> = {};
    for (let i in dict) {
        let v = hyphenate(i);
        (forward as any)[dict[i]] = v;
        (reverse as any)[v] = dict[i];
    }
    return {
        toRouteParam(value) {
            return forward[value]! || undefined;
        },
        fromRouteParam(value) {
            return reverse[value]! || undefined;
        }
    };
}

export const CampaignCategoryMap = createMap(CampaignCategories);
export const MyCustomerReportTypeMap = createMap(MyCustomerReportTypes);
export const ReminderIDMap = createMap(ReminderIDs);
